import StorefrontIcon from '@mui/icons-material/Storefront';
import ProductsAllocationsList from "./ProductsAllocationsList";

export default {
    icon: StorefrontIcon,
    list: ProductsAllocationsList,
};
